"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardGrid = BoardGrid;
const React = __importStar(require("react"));
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const BoardTiles_1 = require("./BoardTiles");
const context_1 = require("./context");
const PieceDragContext_1 = require("./drag/PieceDragContext");
const BoardItems_1 = require("./items/BoardItems");
const useStyles = (0, react_jss_1.createUseStyles)({
    root: {
        position: "relative",
        width: "100%",
        height: "100%",
        containerName: "board",
        containerType: "size",
    },
    board: ({ width, height }) => ({
        position: "relative",
        aspectRatio: `${width} / ${height}`,
        // portrait
        [`@container board (max-aspect-ratio: ${width} / ${height})`]: {
            width: "100%",
            height: "auto",
        },
        // landscape
        [`@container board (min-aspect-ratio: ${width} / ${height})`]: {
            width: "auto",
            height: "100%",
        },
    }),
});
function BoardGrid({ state, renderItem, onDropItem, onClickTile, canDropItem, dragDrop = true, children, renderTileBackground, className, lightTileClassName, darkTileClassName, }) {
    const context = (0, react_1.useMemo)(() => ({
        state,
        tileBackgroundRenderer: renderTileBackground,
    }), [state, renderTileBackground]);
    const styles = useStyles({ width: state.width, height: state.height });
    const surfaceRef = React.useRef(null);
    const handleDrop = React.useCallback((id, x, y) => {
        onDropItem === null || onDropItem === void 0 ? void 0 : onDropItem({ id, x, y });
    }, [onDropItem]);
    const handleCanDrop = React.useCallback((id, x, y) => {
        if (!dragDrop) {
            return false;
        }
        return canDropItem ? canDropItem(id, x, y) : true;
    }, [dragDrop, canDropItem]);
    (0, PieceDragContext_1.useDropSurface)(surfaceRef, state.width, state.height, handleDrop, handleCanDrop);
    return (React.createElement("div", { className: (0, classnames_1.default)(styles.root, className) },
        React.createElement(context_1.BoardContextProvider, { value: context },
            React.createElement("div", { className: styles.board, ref: surfaceRef },
                children,
                React.createElement(BoardTiles_1.BoardTiles, { lightTileClassName: lightTileClassName, darkTileClassName: darkTileClassName, onClick: onClickTile }),
                React.createElement(BoardItems_1.BoardItems, { render: renderItem, dragDrop: dragDrop })))));
}
